import './bottomnav.css';

function HomeIcon({ active }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 11.5 12 4l8 7.5"
        stroke={active ? '#6c4ce8' : '#9992b8'}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10v9a1 1 0 0 0 1 1h4v-6h2v6h4a1 1 0 0 0 1-1v-9"
        stroke={active ? '#6c4ce8' : '#9992b8'}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CompassIcon({ active }) {
  const c = active ? '#6c4ce8' : '#9992b8';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8.5" stroke={c} strokeWidth="2.2" />
      <path d="M14.8 9.2 13 13l-3.8 1.8L11 11l3.8-1.8Z" fill={c} />
    </svg>
  );
}

function BagIcon({ active }) {
  const c = active ? '#6c4ce8' : '#9992b8';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6 8h12l-1 12H7L6 8Z" stroke={c} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" stroke={c} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

function UserIcon({ active }) {
  const c = active ? '#6c4ce8' : '#9992b8';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.6" stroke={c} strokeWidth="2.2" />
      <path d="M5 19c1.4-3.4 4-5 7-5s5.6 1.6 7 5" stroke={c} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

const ITEMS = [
  { key: 'home', label: 'Home', Icon: HomeIcon },
  { key: 'journey', label: 'Journey', Icon: CompassIcon },
  { key: 'shops', label: 'Shops', Icon: BagIcon },
  { key: 'profile', label: 'Profile', Icon: UserIcon },
];

export default function BottomNav({ active, onHome, onJourney, onShops, onProfile }) {
  const handlers = { home: onHome, journey: onJourney, shops: onShops, profile: onProfile };

  return (
    <nav className="bottom-nav">
      {ITEMS.map(({ key, label, Icon }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            className={'bottom-nav-item' + (isActive ? ' bottom-nav-item-active' : '')}
            onClick={handlers[key]}
          >
            <span className="bottom-nav-icon">
              <Icon active={isActive} />
            </span>
            <span className="bottom-nav-label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
